import React, {Component} from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";
import {
    loadInfoProtectoraDetailImagenYVideo,
} from '../../../AnimalList/actions/actionsAnimalList';

class ImagesVideosDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            countImagesLoad_2: 0,
            mode_2: "fotos"
        };
        this.handleImagesLoad = this.handleImagesLoad.bind(this);
    }

    handleImagesLoad(){
        this.setState({countImagesLoad_2: this.state.countImagesLoad_2 + 1});
    }

    renderIndicatorsImages() {
        if (this.props.infoProtectoraDetail === undefined || this.props.infoProtectoraDetail.galeria_imagenes === undefined || this.props.infoProtectoraDetail.galeria_imagenes.length === 0) {
            return (
                <div>
                </div>
            );
        } else {
            return this.props.infoProtectoraDetail.galeria_imagenes.map((srcImage, index) => {
                let classIndicator = "";
                if (index === 0) {
                    classIndicator += " active";
                }
                let slideNumber = index.toString();
                return (
                        <li key={index} data-target="#carouselProtectora" data-slide-to={slideNumber} className={classIndicator}></li>
                );
            })
        }
    }

    renderIndicatorsVideos() {
        if (this.props.infoProtectoraDetail.galeria_videos.length === 0) {
            return (
                <div>
                </div>
            );
        } else {
            return this.props.infoProtectoraDetail.galeria_videos.map((srcVideo, index) => {
                let classIndicator = "";
                if (index === 0) {
                    classIndicator += " active";
                }
                let slideNumber = index.toString();
                return (
                    <li key={index} data-target="#carouselProtectora" data-slide-to={slideNumber} className={classIndicator}></li>
                );
            })
        }
    }

    renderImages() {
        if (!this.props.infoProtectoraDetail || !this.props.infoProtectoraDetail.galeria_imagenes || this.props.infoProtectoraDetail.galeria_imagenes.length === 0) {
            return (
                <div>
                    <h6>No tiene más fotos</h6>
                </div>
            );
        } else {
            return this.props.infoProtectoraDetail.galeria_imagenes.map((srcImage, index) => {
                let classImage = "carousel-item";
                if (index === 0) {
                    classImage += " active";
                }
                return (
                    <div className={classImage} key={index}>
                        <LazyLoadImage threshold={150}
                            className="d-block img-fluid"
                            src={srcImage.url}
                            key={index} alt=""
                            onLoad={this.handleImagesLoad}
                        />
                    </div>
                );
            })
        }
    }

    renderVideos() {
        if (this.props.infoProtectoraDetail.galeria_videos.length === 0) {
            return (
                <div>
                    <h6>Sin Videos</h6>
                </div>
            );
        } else {
            return this.props.infoProtectoraDetail.galeria_videos.map((srcVideo, index) => {
                let classVideo = "carousel-item";
                if (index === 0) {
                    classVideo += " active";
                }
                return (
                    <div className={classVideo} key={index}>
                        <Player
                            playsInline={true}
                            fluid = {true}
                        >
                            <BigPlayButton position="center" />
                            <source src={srcVideo}/>
                        </Player>
                    </div>
                );
            })
        }
    }

    render() {
        let especie = "Perro";
        let showInfo = undefined;
        let classfoto = "btn btn-outline-primary";
        let classvideo = "btn btn-outline-primary";
        let classPrev = "carousel-control-prev";
        let classNext = "carousel-control-next";
        // if (this.props.animalDetailProtectoraImagenYVideo.load) {
        //     showInfo = true;
        // } else {
        //     showInfo = false;
        // }
        if (this.state.mode_2 === "fotos") {
            classfoto += " active";
            if (this.props.animalDetailProtectoraImagenYVideo === undefined
                || this.props.animalDetailProtectoraImagenYVideo.galeria_imagenes === undefined
                || this.props.animalDetailProtectoraImagenYVideo.galeria_imagenes.length === 0) {
                classPrev += " carousel-control-hidden";
                classNext += " carousel-control-hidden";
            }

        }
        return (
            <div className="card-detail-protectora-imagen-video">
                {showInfo &&
                <div className="cardInfoDetailShow">
                    <div className="informationDetailDescription_withImages">
                        <div className="contentImageVideo">
                            {/*<div className="btn-group switch-imagen-video" role="group" aria-label="Default button group">*/}
                            {/*    <button type="button" data-value="fotos" className={classfoto}>Fotos</button>*/}
                            {/*    <button type="button" data-value="videos" className={classvideo}>Videos</button>*/}
                            {/*</div>*/}
                            <div id="carouselProtectora" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    {(this.state.mode_2 === "fotos") ? this.renderIndicatorsImages() : this.renderIndicatorsVideos()}
                                </ol>
                                <div className="carousel-inner" role="listbox">
                                    {(this.state.mode_2 === "fotos") ? this.renderImages() : this.renderVideos()}
                                </div>
                                <a className={classPrev} href="#carouselProtectora" role="button" data-slide="prev">
                                    <span className="carousel-control-prev-icon las la-3x la-angle-left" aria-hidden="true"></span>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className={classNext} href="#carouselProtectora" role="button" data-slide="next">
                                    <span className="carousel-control-next-icon las la-3x la-angle-right" aria-hidden="true"></span>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                }
                {!showInfo &&
                <div className="informationDetail">

                </div>
                }
            </div>
        );
    }

    componentWillMount() {
        loadInfoProtectoraDetailImagenYVideo(this.props.idProtectora, "pesada");
    }


    componentDidMount() {
        /*var inputs = $(".progress-container-detail").find($("label"));
        for (var i = 0; i < inputs.length; i++) {
            var index = i + 1;
            var time = ((inputs.length) - i ) * 100;
            $(".progress-container-detail label:nth-child(" + index + ")").css("-webkit-animation", "anim 3s " + time + "ms infinite ease-in-out");
            $(".progress-container-detail label:nth-child(" + index + ")").css("-animation", "anim 3s " + time + "ms infinite ease-in-out");
        }*/

        //var nav = $('.card-detail-protectora-imagen-video');

        //var animateTime = 20;
        //this.autoHeightAnimate(nav, animateTime, false);

        //let that = this;
        //$(window).on('resize', function(){
        //    that.autoHeightAnimate(nav, animateTime);
        //});
    }

    componentDidUpdate() {
        // if ((this.state.countImagesLoad_2 >= this.props.animalDetailProtectoraImagenYVideo.galeria_imagenes.length) && this.props.animalDetailProtectoraImagenYVideo.load) {
        //var nav = $('.card-detail-protectora-imagen-video');

            //var animateTime = 20;
        //this.autoHeightAnimate(nav, animateTime, true);
        // }

        $('.switch-imagen-video button').on("click", (e) => {
            let newmode = $(e.currentTarget).data("value");
            if (this.state.mode_2 !== newmode)
            this.setState({mode_2: newmode});
        });
    }


    autoHeightAnimate(element, time, mount){
        //console.log("ImagesVideosDetail::autoHeightAnimate()");
        var toHide = (this.state.countImagesLoad_2 >= this.props.animalDetailProtectoraImagenYVideo.galeria_imagenes.length) && this.props.animalDetailProtectoraImagenYVideo.load;
        var curHeight = element.height(); // Get Default Height
        var autoHeight = element.css('height', 'auto').height(); // Get Auto Height
        element.height(curHeight); // Reset to Default Height
        if (!toHide) {
            autoHeight += 40;
        }
        element.stop().animate({ height: autoHeight }, time, function() {
            if (toHide) {
                $(".card-detail-protectora-imagen-video").removeClass("blink");
                // $("#carouselProtectora").removeClass("carouselHidden");
            }
        }); // Animate to Auto Heights
    }

}


//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default ImagesVideosDetail
